




































































































import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'

import Logo from '@/components/shared/atoms/Logo'
import NewsList from '@/components/News/List'
import VoiceList from '@/components/Voice/List'
import Banner from '@/components/shared/organisms/Banner'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import Button from '@/components/shared/atoms/Button/Button'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '@/const'

interface IData {
  featuresData: { id: number; title: string; image: string; content: string }[]
  slideImageIndex: number
  slideTimer: NodeJS.Timeout | null
  featuredNewsId: string
}

export default Vue.extend({
  components: {
    Logo,
    NewsList,
    Banner,
    LinkButton,
    VoiceList,
    Button
  },
  data(): IData {
    return {
      featuredNewsId: '62Y9jguz3lUoZz4vacCHNN',
      featuresData: [
        {
          id: 1,
          title: 'スクールの写真がいつでもどこでも',
          image: '/static/top/pic-features-01.png',
          content: '園・学校（スクール）内のイベント写真が、スクール内掲示版での写真貼り出しと同じように、スマートフォンやパソコンからお楽しみいただけます。'
        },
        {
          id: 2,
          title: '安心のセキュリティ',
          image: '/static/top/pic-features-02.png',
          content: '写真や個人情報を含む全ての通信の暗号化・不正アクセスや写真データの漏洩防止等のセキュリティ対策を実施しており、安心してご利用いただけます。'
        },
        {
          id: 3,
          title: '導入数圧倒的No.1',
          image: '/static/top/pic-features-03.png',
          content: '日本全国の公私保育園～大学まで教育機関において導入されています。たくさんの保護者さまに使っていただいている、No.1スクールフォト販売サービスです。'
        }
      ],
      slideImageIndex: 0,
      slideTimer: null
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        newsRepository: this.$newsRepository,
        voiceRepository: this.$voiceRepository,
        featuredNewsId: this.featuredNewsId
      })
    }
  },
  mounted() {
    this.slideTimer = setInterval(this.slide, 5000)
  },
  destroyed() {
    if (this.slideTimer) clearInterval(this.slideTimer)
  },
  methods: {
    setFeatureCount(id: number): string {
      return '0' + String(id)
    },
    slide() {
      const images = document.getElementsByClassName('slide') as HTMLCollectionOf<Element>
      this.slideImageIndex = this.slideImageIndex < images.length - 1 ? this.slideImageIndex + 1 : 0
      const current = images[this.slideImageIndex]
      const prev = images[this.slideImageIndex - 1] ? images[this.slideImageIndex - 1] : images[images.length - 1]
      current.classList.add('fadein')
      current.classList.remove('fadeout')
      prev.classList.remove('fadein')
      prev.classList.add('fadeout')
    },
    formatDate(date: string) {
      const dateFormat = dayjs(date, DATE_FORMAT)
      return dateFormat.format('YYYY.MM.DD')
    }
  }
})
